import { booleanPointInPolygon } from "@turf/turf";

export const isPointInPolygon = (point, polygon) => {
  if (polygon.coordinates.length > 0)
    return booleanPointInPolygon(point, polygon);
};
